import MyFlow from "flow/MyFlow";

export default function protect(myFlow: MyFlow, context: any, method: () => any): (...params: any[]) => any {
    if (method === undefined || method === null) {
        myFlow.warn("Protect was called with undefined or null method, so the call will always fail.");
    }

    return function (...params: any[]) {
        try {
            return method.apply(context, params);
        } catch (exception) {
            let exceptionHandled = false;
            try {
                exceptionHandled = myFlow.exception(exception);
            } catch (e) {}

            // To detect errors during unit testing when myFlow is stubbed.
            if (!exceptionHandled) {
                if (exception.stack) {
                    myFlow.error(exception.stack);
                } else if (exception.message) {
                    myFlow.error(exception.message);
                } else {
                    myFlow.error(exception);
                }

                throw exception;
            }

            return undefined;
        }
    };
}
